import { ChangeEvent, FC, useEffect, useState, MouseEvent } from "react";
import "./AdminTickets.css";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import UserItem from "../../UI/list-item/UserItem";
import { getUsersBySearch } from "../../../redux/requests/UserRequests";
import AddMessage from "../../UI/add-message-modal/AddMessageModal";

interface IAdminUsersProps {}

const AdminUsers: FC<IAdminUsersProps> = () => {
  const dispatch = useAppDispatch();
  const users = useAppSelector((state) => state.users.users);

  const [search, setSearch] = useState<string>("");
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);
  const [isMessageModalActive, setIsMessageModalActive] = useState(false);

  useEffect(() => {
    dispatch(getUsersBySearch(""));
  }, [dispatch]);

  const onSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const onSearchButtonClick = () => {
    dispatch(getUsersBySearch(search));
  };

  const onAddMessageClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsMessageModalActive(true);
  };

  const onUserCheckboxChange = (id: string, checked: boolean) => {
    setSelectedUserIds((prev) => {
      if (checked) {
        if (prev.includes(id)) return prev;
        return [...prev, id];
      } else {
        return prev.filter((x) => x !== id);
      }
    });
  };

  return (
    <div className="admin-tickets">
      <div className="dialog-list">
        <div className="search-box">
          <input
            type="text"
            placeholder="Имя или номер клиента"
            onChange={onSearchInputChange}
          />
          <button onClick={onSearchButtonClick}>Поиск</button>
          <button onClick={onAddMessageClick}>Отправить сообщение</button>
        </div>

        <h3>Клиенты</h3>
        <div className="modal-body">
          <ul id="operators-list">
            {users.map((item) => (
              <UserItem
                checkboxVisible={true}
                user={item}
                key={item.id}
                checked={selectedUserIds.includes(item.id)}
                onCheckChange={onUserCheckboxChange}
              />
            ))}
          </ul>
        </div>
      </div>

      {isMessageModalActive && (
        <AddMessage
          isActive={isMessageModalActive}
          setIsActive={setIsMessageModalActive}
          selectedUserIds={selectedUserIds}
        />
      )}
    </div>
  );
};

export default AdminUsers;
